import { render, staticRenderFns } from "./FormType1.vue?vue&type=template&id=7e297e12&"
import script from "./FormType1.vue?vue&type=script&lang=js&"
export * from "./FormType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports